(function() {
  function onTidioChatApiReady() {
    window.tidioChatApi.hide();
  }
  
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  }

  let button = document.querySelector(".chat-button");

  if (button != null) {
    button.addEventListener("click", (event) => {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
      event.preventDefault();
    });
  }
})();